import api from './api';

// ── Role Management ──────────────────────────────────────────────────

export async function assignRole(userId: string, roleName: string): Promise<any> {
  const response = await api.put(`/admin/users/${userId}/role`, { role_name: roleName });
  return response.data;
}

export async function getUserRole(userId: string): Promise<any> {
  const response = await api.get(`/admin/users/${userId}/role`);
  return response.data;
}

export async function getRoles(): Promise<any[]> {
  const response = await api.get('/admin/roles');
  return response.data;
}

// ── User Profile & Activity ──────────────────────────────────────────

export async function getUserProfile(userId: string): Promise<any> {
  const response = await api.get(`/users/${userId}/profile`);
  return response.data;
}

export async function getUserActivity(
  userId: string,
  skip: number = 0,
  limit: number = 50,
): Promise<any[]> {
  const response = await api.get(`/users/${userId}/activity`, {
    params: { skip, limit },
  });
  return response.data;
}

export async function getUserEntities(
  userId: string,
  entityType?: string,
): Promise<any[]> {
  const params: Record<string, string> = {};
  if (entityType) params.entity_type = entityType;
  const response = await api.get(`/users/${userId}/entities`, { params });
  return response.data;
}

// ── Password Reset ───────────────────────────────────────────────────

export async function resetPassword(userId: string): Promise<any> {
  const response = await api.post(`/admin/users/${userId}/reset-password`);
  return response.data;
}

// ── Invites ──────────────────────────────────────────────────────────

export async function createInvite(
  email: string,
  roleName: string,
  templateId?: string,
): Promise<any> {
  const body: Record<string, string> = { email, role_name: roleName };
  if (templateId) body.template_id = templateId;
  const response = await api.post('/admin/invites', body);
  return response.data;
}

export async function getInvites(): Promise<any[]> {
  const response = await api.get('/admin/invites');
  return response.data;
}

export async function revokeInvite(inviteId: string): Promise<any> {
  const response = await api.delete(`/admin/invites/${inviteId}`);
  return response.data;
}

// ── Templates ────────────────────────────────────────────────────────

export async function getTemplates(): Promise<any[]> {
  const response = await api.get('/admin/templates');
  return response.data;
}

export async function createTemplate(
  name: string,
  roleName: string,
  description?: string,
): Promise<any> {
  const body: Record<string, string> = { name, role_name: roleName };
  if (description) body.description = description;
  const response = await api.post('/admin/templates', body);
  return response.data;
}

export async function deleteTemplate(templateId: string): Promise<any> {
  const response = await api.delete(`/admin/templates/${templateId}`);
  return response.data;
}
